<template>
  <section id="searchform">
    <div class="container-lg mx-auto">
      <div class="text-center">
        <h1>Explore the best Luxury Hotels</h1>
      </div>
      <div class="searchbox-wrapper" style="position: relative">
        <div id="search-from" class="searchboxdiv" @click="showResultsPopup">
          <span v-if="searchString === ''">{{ translations.enter_destination?.[languageCode] ?? 'Enter destination' }}</span>
          <span v-else>{{ searchString }}</span>
        </div>
        <div id="searchFromOverlay" class="uk-box-shadow-large" v-if="showResults">
          <svg v-if="isLoading" xmlns="http://www.w3.org/2000/svg" style="position: absolute;top: 10px;right: 10px;" width="36" height="36" viewBox="0 0 100 100" overflow="visible" fill="#000000" stroke="none"><defs><circle id="loader" r="4" cx="50" cy="50" transform="translate(0 -30)"/></defs><use xlink:href="#loader" transform="rotate(30 50 50)"><animate attributeName="opacity" values="0;1;0" dur="1s" begin="0.08s" repeatCount="indefinite"></animate></use><use xlink:href="#loader" transform="rotate(60 50 50)"><animate attributeName="opacity" values="0;1;0" dur="1s" begin="0.17s" repeatCount="indefinite"></animate></use><use xlink:href="#loader" transform="rotate(90 50 50)"><animate attributeName="opacity" values="0;1;0" dur="1s" begin="0.25s" repeatCount="indefinite"></animate></use><use xlink:href="#loader" transform="rotate(120 50 50)"><animate attributeName="opacity" values="0;1;0" dur="1s" begin="0.33s" repeatCount="indefinite"></animate></use><use xlink:href="#loader" transform="rotate(150 50 50)"><animate attributeName="opacity" values="0;1;0" dur="1s" begin="0.42s" repeatCount="indefinite"></animate></use><use xlink:href="#loader" transform="rotate(180 50 50)"><animate attributeName="opacity" values="0;1;0" dur="1s" begin="0.50s" repeatCount="indefinite"></animate></use><use xlink:href="#loader" transform="rotate(210 50 50)"><animate attributeName="opacity" values="0;1;0" dur="1s" begin="0.58s" repeatCount="indefinite"></animate></use><use xlink:href="#loader" transform="rotate(240 50 50)"><animate attributeName="opacity" values="0;1;0" dur="1s" begin="0.67s" repeatCount="indefinite"></animate></use><use xlink:href="#loader" transform="rotate(270 50 50)"><animate attributeName="opacity" values="0;1;0" dur="1s" begin="0.75s" repeatCount="indefinite"></animate></use><use xlink:href="#loader" transform="rotate(300 50 50)"><animate attributeName="opacity" values="0;1;0" dur="1s" begin="0.83s" repeatCount="indefinite"></animate></use><use xlink:href="#loader" transform="rotate(330 50 50)"><animate attributeName="opacity" values="0;1;0" dur="1s" begin="0.92s" repeatCount="indefinite"></animate></use><use xlink:href="#loader" transform="rotate(360 50 50)"><animate attributeName="opacity" values="0;1;0" dur="1s" begin="1.00s" repeatCount="indefinite"></animate></use></svg>
          <input type="text" id="searchFromInput" name="searchFromInput" autocomplete="off" class="no-outline" :placeholder="translations.search_hotel?.[languageCode] ?? 'Search for hotel, country or city...'" v-model="searchString" @click="searchString = ''" @input="searchStringChange" ref="searchField" />
          <div style="border-bottom: 1px solid #e5e5e5; margin-top: 10px;"></div>
          <div v-if="showResults">
            <ul class="list-group list-group-flush">
              <li class="list-group-item" v-for="item in cities" @click="goToCity(item.id)">
                {{ item.name }}
                <div>{{ translations.city?.[languageCode] ?? 'City' }}, {{ item.country }}</div>
              </li>
              <li class="list-group-item" v-for="item in hotels" @click="goToHotel(item.id)">
                {{ item.name }}
                <div>{{ translations.hotel?.[languageCode] ?? 'Hotel' }}, {{ item.city}}, {{ item.country }}</div>
              </li>
            </ul>
          </div>
          <div id="search-from-not-found" v-if="noResults">
            <div class="uk-alert-danger" uk-alert>
              <a class="uk-alert-close" uk-close></a>
              <p>Your search did not result in any matches. Please try again.</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  </section>
  <div class="search-overlay" v-if="showResults" @click="showResults = false"></div>
</template>

<script>
export default {
  name: "SearchFormHome",
  props: {
    destination: String,
  },
  data() {
    return {
      searchString: "",
      selectedHotel: null,
      isLoading: false,
      isLoading2: false,
      timeout: null,
      showResults: false,
      cities: [],
      hotels: [],
      type: null,
      dataId: null,
      noResults: false,
      translations: window.translations,
      languageCode: localStorage.getItem('locale') ?? 'en'
    }
  },
  methods: {
    showResultsPopup() {
      this.showResults = true;
    },
    toisodate (thisdate) {
      var mm = thisdate.getMonth() + 1; // getMonth() is zero-based
      var dd = thisdate.getDate();

      return [thisdate.getFullYear(),
        '-'+(mm>9 ? '' : '0') +mm,
        '-'+(dd>9 ? '' : '0') + dd
      ].join('');
    },
    searchStringChange() {
      this.hotels = [];
      this.cities = [];
      if (this.searchString.length > 2) {
        clearTimeout(this.timeout);
        this.timeout = setTimeout(() => {
          this.isLoading = true;
          axios.get('/api/suggest', { params: { "searchString": this.searchString}}).then((res) => {
            this.isLoading = false;
            if(res.data.success) {
              this.cities = res.data.cities;
              this.hotels = res.data.hotels;
              this.showResults = true;
              this.isLoading = false;
            }
          })
        }, 250);
      } else {
        this.isLoading = false;
        this.awaitingSearch = false;
      }
    },
    formatDate(date) {
      let d = new Date(date),
          month = '' + (d.getMonth() + 1),
          day = '' + d.getDate(),
          year = d.getFullYear();

      if (month.length < 2)
        month = '0' + month;
      if (day.length < 2)
        day = '0' + day;
      return [year, month, day].join('-');
    },
    updateDates() {
      if(!this.dataId) return false;
      if(this.type === 'hotel') {
        location.href= '/hotels?hotel=' + this.dataId ;
      } else {
        location.href = '/hotels?city=' + this.dataId;
      }
    },
    goToCity(city) {
      this.showResults = false;
      this.type = 'city';
      this.dataId = city;
      this.updateDates();
    },
    goToHotel(hotel) {
      this.showResults = false;
      this.type= 'hotel';
      this.dataId = hotel;
      this.updateDates();
    }
  },
  watch: {
    checkinData(value) {
      this.checkin = value;
    },
    checkoutData(value) {
      this.checkout = value;
    },
    destination(value) {
      this.searchString = value;
    },
    showResults(value) {
      if(value) {
        this.$nextTick(() => {
          this.$refs.searchField.focus();
        });
      }
    }
  }
}
</script>

<style scoped lang="scss">
.search-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100vh;
  background-color: #000;
  opacity: 0.5;
  z-index: 1;
}
.form-control {
  margin: 0;
  padding: 0;
  border: 0;
  &:focus {
    border: 0;
    box-shadow: none;
  }
}
.search-suggestions {
  -webkit-box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.51);
  -moz-box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.51);
  box-shadow: 0px 0px 5px 1px rgba(0,0,0,0.51);
  position: absolute;
  width: 100%;
  z-index: 1;
  li {
    &:hover {
      background-color: #f5f5f5;
      cursor: pointer;
    }
  }
}
#searchFromInput {
  width: calc(100% - 20px);
  background-color: #fff;
  border: 0;
  padding: 5px 10px;
  font-size: 18px;
  font-weight: 400;
  &:focus {
    outline: none;
  }
}
#searchform {
  background: url('/images/luxurybg.jpg');
  background-repeat: no-repeat;
  background-position: center center;
  background-size: cover;
  color:#fff;
  padding-top: 40px;
  padding-bottom: 40px;
}
#searchform h1 { text-shadow: 2px 2px 1px rgba(0,0,0,0.21); font-size: 30px; margin-bottom: 20px; font-weight: 400; }
#searchform .searchbox {

  width: 100%;
  border-radius: 5px;
  font-size: 24px;
  padding: 20px 10px;
  margin-bottom: 10px;
  height: 55px;

}
.searchbox-wrapper { position: relative; }
#searchform .fromdate, #searchform .todate {

  width: 100%;
  border-radius: 5px;
  font-size: 18px;
  padding: 3px 10px;
  cursor: pointer;
  padding-top: 15px;
}
.searchboxdiv { font-size: 22px; background:#fff; border-radius: 3px; padding: 10px 10px; color:#666; margin-left: 2px; margin-right: 2px; margin-bottom: 10px; }
#searchform {
  cursor: pointer;
}
.search-fromdate { margin-right: 5px; position: relative; font-size: 14px; width: 50%; }
.search-from-header { position: absolute; top: 3px; left: 10px; font-size: 11px; color:#333; }
.search-todate { margin-left: 5px; position: relative; font-size: 14px; width: 50%; }
.search-to-header { position: absolute; top: 3px; left: 10px; font-size: 11px; color:#333;  }

.searchresults-search { border: 0; font-size: 20px; width: calc( 100% - 40px ); display: block; outline: none; }

.searchresults {
  position: absolute;
  left: -5px;
  right: -5px;
  top: 0px;
  height: 300px;
  background-color:#fff;
  padding: 10px;
  z-index: 99999;
  box-shadow: 0 14px 25px rgba(0,0,0,.16);
  border-radius: 5px;
  overflow: hidden;
}
.searchresults-close {

  position: absolute;
  right: 10px;
  top: 5px;
  color:#999;
  font-size: 20px;
}
.searchresults-top { padding-top: 5px; padding-bottom: 10px; border-bottom: 1px solid #eaeaea; position: relative; }
.searchresults-hits { color:#333; font-size: 14px; height: 100%; overflow-y: auto; }
.searchresults-hits a { text-decoration: none; color:#333; font-size: 14px; text-decoration: none; display: block; border-bottom: 1px solid #eaeaea; padding-top: 10px; padding-bottom: 10px; }

.flex-row { display: flex; flex-direction: row; }
.flex-col { display: flex; flex-direction: column; }
.flex-align { align-items: center; }

.hotels-header { padding: 10px; background-color:#eaeaea; }

.hotel-list { padding: 0; margin: 0; list-style: none; }
.hotel-list-item {

  margin-bottom: 10px;
  padding: 10px;
  border-bottom: 0;
  border-radius: 5px;
}
.hotel-list-item:nth-child(even) { background-color:#f0f0f0; }
.hotel-list-item:nth-child(odd) { background-color:#f5f5f5; }


.image-container {

  background-position: center center;
  background-size: cover;
  width: 100%;
  height: 200px;
  border-radius: 5px;
}


.hotel-image { width: 150px; min-width: 150px; padding-right: 10px; position: relative; }
.hotel-image .hotel-image-pro, .hotel-image .hotel-image-medium {

  color:#fff;
  border-radius: 5px 0 0 0;
  padding: 2px 5px;
  font-size: 12px;
  font-weight: 500;
  display: inline-block;
  position: absolute;
  left: 0;
  top: 0;
}
.hotel-image .hotel-image-pro { background:#66A400;  }
.hotel-image .hotel-image-medium { background:#CC6600;  }

.hotel-text { width: 100%; }
.hotel-name { font-size: 17px; font-weight: 500; color:#369; line-height: 18px; margin-bottom: 5px; }
.hotel-rating { font-size: 14px; }
.hotel-rating .hotel-rating-review { background: #c3d2fc; padding: 2px; border-radius: 2px; padding-left: 5px; padding-right: 5px; }
.hotel-adress { font-size: 14px; }
.hotel-rooms-left { font-size: 12px; color:#cc0000; }
.hotel-mobileprice span { font-size: 12px; color:#fff; background: #FF9260; border-radius: 10px; padding: 0px 8px; display: inline-block; }
.hotel-pros { font-size: 12px; color:#3b8d21; }
.hotel-price { font-size: 17px; font-weight: 600; color:#111; text-align: right; line-height: 14px; margin-top: 10px; }
.hotel-booker { font-size: 10px; text-align: right; margin-bottom: 5px; color:#afcdbc; }
.hotel-button { text-align: right;  }
.hotel-button span.submit { display: inline-block; padding: 5px 10px; color:#fff; background:#006dba; text-decoration: none; border-radius: 5px; font-weight: 500; }

.hotels-more { background-color:#e5e5e5; padding: 10px; border-radius: 5px; text-align: center;  }
.hotels-more-top { font-size: 18px; }
.hotels-more-bottom { font-size: 14px; }

#highlighted-hotel { background-color:#f0f0f0; padding: 10px; border-radius: 5px;  }
.highlighted-text { background-color:transparent; padding: 10px; border-radius: 5px; display: block; text-align: center; font-weight: 500; color:#333399; }

.hotels-near { padding-top: 10px; padding-bottom: 10px; }

.fixed-nav nav {
  position: fixed;
  top:0;
  z-index: 1;
  background-color:#fff;
  width: 100%;
}

.outlink { text-decoration: none; color:#333; }

section { margin-top: 10px; }



#searchFromOverlay {
  overflow-y: scroll;
  position: absolute;
  left: 0px; right: 0px;
  top: -15px;
  width: 100%;
  min-height: 300px;
  background-color:#fff;
  border-radius: 5px;
  padding: 10px;
  z-index: 99999;
  box-shadow: 0 14px 25px rgba(0,0,0,.16);
}
#siteOverlay {

  display: none;
  position: fixed;
  left: 0px;
  right: 0px;
  top: 0px;
  bottom: 0px;
  background-color:#000;
  opacity: 0.5;
  z-index: 10;
}



@media screen and ( max-width: 1140px ) {

  #searchform .searchbox {

    width: 100%;
    border-radius: 5px;
    font-size: 18px;
    padding: 20px 10px;
    margin-bottom: 10px;
    height: 45px;
  }

  .searchboxdiv { font-size: 18px; background:#fff; border-radius: 3px; padding: 10px 10px; color:#666; margin-left: 2px; margin-right: 2px; margin-bottom: 10px; }

  .highlighted-text { background-color:#e5e5e5; padding: 10px; border-radius: 5px; display: block; text-align: center; font-weight: 500; color:#333399; }

  #searchform, .highlighted-hotel, .hotel-list-item, .hotels-more, .highlighted-text { border-radius: 0; }

  .hotels-near { padding-left: 10px; padding-right: 10px; }

  .hotellist.container-lg { padding-left: 0; padding-right: 0; }

  .hotel-list-item {

    margin-bottom: 0px;
    padding: 10px;
    border-bottom: 1px solid #e5e5e5;
  }

  #searchform { padding: 20px 10px; }
  #searchform h1 { text-shadow: 2px 2px 1px rgba(0,0,0,0.21); font-size: 22px; margin-bottom: 20px; font-weight: 400; }
  section { margin-top: 0px; }
}

@media screen and ( max-width: 640px ) {

  .tiny-font { font-size: 12px; }

  section { margin-top: 0px; }

}
</style>
